import EmployeeList from '~/themes/base/components/content/EmployeeList'

export default {
  extends: EmployeeList,
  props: {
    employees: {
      type: Object,
      required: true,
    },
    headingClass: {
      type: String,
      default: '',
    },
    headingText: {
      type: String,
      default() {
        return this.$t('EmployeeList.heading')
      },
    },
  },
}
